import React from 'react';

import {
  Squares2X2Icon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';
import UserMenu from './UserMenu';
import ThemeToggle from '../ThemeToggle';
import LanguageSwitcher from '../LanguageSwitcher';
import { MenuItemType } from '../../config/app.config';

interface PcMenuProps {
  menuItems: MenuItemType[];
  selectedKey: string;
  userName?: string;
  userRole?: string;
  coinBalance?: number;
  onMenuClick: (key: string) => void;
  onLogout: () => void;
  onProfileClick: () => void;
  onCoinsClick: () => void;
}

const PcMenu: React.FC<PcMenuProps> = ({
  menuItems,
  selectedKey,
  userName,
  userRole,
  coinBalance = 0,
  onMenuClick,
  onLogout,
  onProfileClick,
  onCoinsClick,
}) => {
  return (
    <aside className="sidebar bg-bg-surface w-20">
      <div className="h-full flex flex-col">
        {/* 侧边栏头部 */}
        <div className="p-3">
          <div className="flex items-center justify-center">
            <button
              onClick={() => onMenuClick('dashboard')}
              className={`w-10 h-10 bg-gradient-to-br from-primary to-primary-light rounded-xl flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(255,92,0,0.3)] transition-all cursor-pointer`}
            >
              <Squares2X2Icon className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>

        {/* 导航菜单 */}
        <nav className="flex-1 px-2 py-2 pt-12 overflow-y-auto">
          <ul className="space-y-1">
            {menuItems.map((item, index) => {
              if (item.type === 'divider') {
                return (
                  <li key={`divider-${index}`} className="py-1">
                    <div className="border-t border-border-subtle mx-3" />
                  </li>
                );
              }

              const IconComponent = item.icon;
              return (
                <li key={item.key}>
                  <button
                    onClick={() => onMenuClick(item.key)}
                    className={`w-full flex flex-col items-center justify-center px-1 py-2 rounded-lg transition-all duration-200 text-center ${selectedKey === item.key
                      ? 'bg-bg-elevated text-gray-50'
                      : 'text-gray-400 hover:text-gray-200 hover:bg-bg-elevated/50'
                      }`}
                  >
                    <IconComponent className="w-5 h-5" />
                    <span className={`text-xs mt-1 leading-tight ${selectedKey === item.key ? 'font-medium' : ''}`}>
                      {item.label}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* 侧边栏底部 */}
        <div className="px-2 py-2 border-t border-border-subtle">
          {/* 剧点余额 */}
          <button
            onClick={onCoinsClick}
            className="w-full mb-1 py-1.5 cursor-pointer"
          >
            <div className="text-xs text-primary flex items-center justify-center gap-1 font-mono font-semibold">
              <CurrencyDollarIcon className="w-4 h-4" />
              {coinBalance}
            </div>
          </button>

          <div className="flex flex-col items-center gap-0.5">
            <ThemeToggle compact />
            <LanguageSwitcher compact />
            <UserMenu
              userName={userName}
              userRole={userRole}
              onProfileClick={onProfileClick}
              onCoinsClick={onCoinsClick}
              onLogout={onLogout}
              collapsed={true}
            />
          </div>
        </div>



      </div>
    </aside>
  );
};

export default PcMenu;
